import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import authService from '../services/authService';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email.trim()) newErrors.email = 'Էլ. հասցեն պարտադիր է';
    if (!formData.password) newErrors.password = 'Գաղտնաբառը պարտադիր է';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setServerError('');
    try {
      await authService.login(formData.email.trim().toLowerCase(), formData.password);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setServerError('Սխալ էլ. հասցե կամ գաղտնաբառ');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <h1 className="login-title">Մուտք</h1>

          {serverError && (
            <div className="login-error-banner">{serverError}</div>
          )}

          <form className="login-form" onSubmit={handleSubmit} noValidate>
            <div className="login-field">
              <label htmlFor="email">Էլ. հասցե</label>
              <input
                id="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="email@example.com"
                className={errors.email ? 'error' : ''}
                autoComplete="email"
              />
              {errors.email && <span className="login-error-text">{errors.email}</span>}
            </div>

            <div className="login-field">
              <label htmlFor="password">Գաղտնաբառ</label>
              <input
                id="password"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="••••••"
                className={errors.password ? 'error' : ''}
                autoComplete="current-password"
              />
              {errors.password && <span className="login-error-text">{errors.password}</span>}
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Բեռնվում է...' : 'Մուտք գործել'}
            </button>
          </form>

          <p className="login-footer">
            Չունե՞ք հաշիվ։{' '}
            <Link to="/register">Գրանցվեք</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
